import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SurveyRadioLabel } from '~/widgets/survey/components/ui/SurveyRadioLabel';
import { OutlinedInputWithController } from '~components/reuseable/OutlinedInputWithController';
import { SurveyFormKeyEnum } from '~modules/surveys/forms/SurveyForm';
import { SurveyAnswerModel } from '~modules/surveys/models/SurveyAnswerModel';
import { SurveyExtraQuestionModel } from '~modules/surveys/models/SurveyExtraQuestionModel';
import { SurveyQuestionModel } from '~modules/surveys/models/SurveyQuestionModel';

interface IRadioGroupQuestionProps {
  name: string;
  answers: SurveyAnswerModel[];
}

export const RadioGroupQuestion: React.FC<IRadioGroupQuestionProps> = (props) => {
  const { control } = useFormContext();
  const currentValue: SurveyQuestionModel | SurveyExtraQuestionModel = useWatch({ name: props.name, control });

  const { t } = useTranslation('survey');

  // Render

  return (
    <>
      {currentValue.answers.map(({ answerId, descr, happyIndex, isTextAnswer }) => {
        const isShowTextField =
          isTextAnswer && SurveyFormKeyEnum.answerId in currentValue && currentValue.answerId === answerId;

        return (
          <div key={answerId}>
            <SurveyRadioLabel
              name={`${props.name}.${SurveyFormKeyEnum.answerId}`}
              parentName={props.name}
              happyIndex={happyIndex}
              label={descr}
              value={answerId}
              hookFormProps={{ control }}
            />
            {isShowTextField && (
              <OutlinedInputWithController
                name={`${props.name}.${SurveyFormKeyEnum.textValue}`}
                hookFormProps={{ control }}
                fullWidth
                multiline
                rows={2}
                label={t('input.specify.label')}
                required
                hideErrorMessage
              />
            )}
          </div>
        );
      })}
    </>
  );
};
